import { useState } from 'react';

type UseMetricSelectionReturn = {
  selectedMetrics: Set<string>;
  handleMetricToggle: (dataKey: string) => void;
};

export const useMetricSelection = (): UseMetricSelectionReturn => {
  const [selectedMetrics, setSelectedMetrics] = useState<Set<string>>(new Set());

  const handleMetricToggle = (dataKey: string) => {
    setSelectedMetrics(prev => {
      const newSet = new Set(prev);
      if (newSet.has(dataKey)) {
        newSet.delete(dataKey);
      } else {
        newSet.add(dataKey);
      }
      return newSet;
    });
  };

  return {
    selectedMetrics,
    handleMetricToggle,
  };
};
